import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import notAuthSectionsTypes from '../../../../shared/enums/notAuthSectionsTypes';
import LogosIcon from '../../pages/home/sections/logosIcon/LogosIcon';
import InfoPartText from '../../pages/home/sections/infoPartText/InfoPartText';
import ImageTextSection from '../../pages/home/sections/imageTextSection/ImageTextSection';
import InfoFeaturesText from '../../pages/home/sections/infoFeaturesText/InfoFeaturesText';
import InfoNumbers from '../../pages/home/sections/infoNumbers/InfoNumbers';
import Footer from "../../../../shared/layout/footer/Footer";

const NotAuthSections = () => {
    
    const homeData = useSelector((state) => state.uiData.home);
    const [mySections, setMySections] = useState([]);

    useEffect(() => {
        if (homeData) {
            setMySections(homeData
                .filter((section) => section?.sectionType && section?.isVisible === true)
                .flatMap((section) => section.order.map((orderValue, index) => ({ key: `${orderValue}-${index}`, section, orderValue })))
            );
        }
    }, [homeData]);

    const renderSection = (section, key) => {
        const { sectionType, ...sectionProps } = section;
    
        switch (sectionType) {
            case notAuthSectionsTypes.logosIcon:
                return <LogosIcon key={key} {...sectionProps} />;
            case notAuthSectionsTypes.infoPartText:
                return <InfoPartText key={key} {...sectionProps} />;
            case notAuthSectionsTypes.imageTextSection:
                return <ImageTextSection key={key} {...sectionProps} />;
            case notAuthSectionsTypes.infoFeaturesText:
                return <InfoFeaturesText key={key} {...sectionProps} />;
            case notAuthSectionsTypes.infoNumbers:
                return <InfoNumbers key={key} {...sectionProps} />;
            case notAuthSectionsTypes.footer:
                return <Footer key={key} {...sectionProps} />;
            default:
                return null;
        }
    };

    return (
        mySections.sort((a, b) => a.orderValue - b.orderValue).map(({ key, section }) => renderSection(section, key))
    );
};

export default NotAuthSections;